<template>
  <!-- <van-button
    :size="size"
    :icon="icon"
    :type="type"
    :round="round"
    @click="onClick"
    :class="className"
    style="border:none"
  >
    {{likeCount}}
  </van-button> -->
  <div
    @click="onClick"
    :class="className"
    class="like-button"
    :style="customStyle"
  >
    <van-icon :name="icon" />
    <span class="count" v-if="likeCount > 0">{{likeCount}}</span>
  </div>
</template>

<script>
  import { Toast } from 'vant'
  import { Icon } from 'vant'
  import Vue from 'vue'
  Vue.use(Toast)
  Vue.use(Icon)

  export default {
    props: {
      icon: String,
      customStyle: String,
      // type: String,
      round: Boolean,
      count: Number,
      applabel: String,
      classname: String,
      objectid: Number
    },
    computed: {
      likeCount () {
        return this.count + this.localCount
      }
    },
    data () {
      return {
        processing: false, // 点赞操作过程中加锁
        localCount: 0,
        className: null,
        like: null // 如果该用户已经赞过的like对象
      }
    },
    methods: {
      onClick () {
        window.console.log("点击like button")
        let that = this
        if (that.processing == false) {
          that.processing = true
          let params = {
            applabel: that.applabel,
            classname: that.classname,
            objectid: that.objectid
          }
          if (that.like) {
            that.className = null
            that.localCount -= 1
            that.$api.like.remove(that.like.id).then(res => {
              window.console.log(res)
              Toast('已取消赞')
              that.like = null
              that.processing = false
            })
          } else {
            that.className = 'liked'
            that.localCount += 1
            that.$api.like.create(params).then(res => {
              window.console.log(res)
              Toast('已赞')
              that.like = res.data
              that.processing = false
            })
          }
        }
      },
      check_liked () {
        let that = this
        let params = {
          applabel: that.applabel,
          classname: that.classname,
          objectid: that.objectid
        }
        that.$api.like.check(params).then(res => {
          // window.console.log("是否已赞？")
          // window.console.log(res)
          if (res.data) {
            that.className = 'liked'
            that.like = res.data
          }
        })
      }
    },
    mounted () {
      this.check_liked()
    }
  }
</script>

<style lang="css" scoped>
  .liked {
    color: #228df7;
  }
  .like-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .count {
    margin-left: 3px;
  }
</style>
